import React from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box, Image } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Player, Team } from '@/feature/event-details-sbk/types';
import { getTeamName } from '@/feature/event-details-sbk/utils/get-team-name';

const BOX_SIZE = 44;
const LOGO_SIZE = 24;

export const PlayerLogoImage = ({ player }: { player: Player | undefined }) => {
    if (!player) {
        return null;
    }

    const { textColor, backgroundColor } = getTeamColorsLogo(player.team);
    const isValidPlayerNumber = typeof player.player_number === 'number' && player.player_number <= 99;

    return (
        <Box
            borderRadius="r16"
            borderWidth={1}
            borderColor={ds.colorToken.border.strong}
            alignItems="center"
            justifyContent="center"
            width={BOX_SIZE}
            height={BOX_SIZE}
            style={{ backgroundColor }}
        >
            {player.team.logo_url ? (
                <Image resizeMode="contain" source={{ uri: player.team.logo_url }} style={styles.teamLogo} />
            ) : (
                <Text fontFamily="Oswald-SemiBold" fontSize={24} lineHeight={33} style={{ color: textColor }}>
                    {isValidPlayerNumber ? player.player_number : getTeamName(player.team).charAt(0)}
                </Text>
            )}
        </Box>
    );
};

const styles = StyleSheet.create({
    teamLogo: {
        width: LOGO_SIZE,
        height: LOGO_SIZE,
    },
});

const getTeamColorsLogo = (team: Team) => {
    if (!team.primary_color || !team.secondary_color) {
        return {
            textColor: ds.colorValue.text.primary,
            backgroundColor: ds.colorValue.background.neutral.subtle,
        };
    }

    return { textColor: team.secondary_color, backgroundColor: team.primary_color };
};
